import React from "react";
import { SortableElement } from "react-sortable-hoc";

import Button from "components/Button";
import Link from "components/Link";

import "./_style.scss";

const SortableImage = SortableElement(({
  value, onClick, index, primaryItem,
}) => (
  <div className="sortable-item image-input__containers" data-test="uploaded-image">
    <Button
      className="image-input__containers-delete"
      onClick={onClick}
      value={value.id}
      data-test="image-input__containers-delete"
      style={{
        position: "absolute",
        right: "5px",
        top: "5px",
        border: "1px solid white",
        backgroundColor: "white",
        fontWeight: "bold",
        fontSize: "11px",
        padding: "2px 6px",
        borderRadius: "44px",
      }}
    >
      X
    </Button>
    <Link key={index} href={`${value.url}`} target="_blank" look="unstyled">
      <img src={value.url && `${value.url}`} width="100%" alt="primary image" />
    </Link>
    { primaryItem
          && (
          <span style={{
            position: "absolute",
            left: "0",
            bottom: "5px",
            width: "100%",
            margin: "0 auto",
            textTransform: "uppercase",
            fontSize: "11px",
            fontWeight: "bold",
            padding: "5px",
            color: "white",
            textAlign: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
          >
            Primary Image
          </span>
          )}
  </div>
));

export default SortableImage;
